import styled from 'styled-components/macro';

const Wrapper = styled.div`
  position: relative;
  margin-bottom: 18px;
`;

export default Wrapper;
